import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';

import DefaultLayout from 'common/Layout/DefaultLayout';

import { accountType } from 'components/utils/function';

const routesPathLottery = (currentUser, i18n, arDailyReport) => {
    const isMasterAccount = accountType('master');

    const privateRoutes = [
        {
            path: '/',
            exact: true,
            component: () => {
                if (isMasterAccount) {
                    return <Redirect to='/reports/winloss_report' />;
                }
                return <Redirect to='/home/dashboard' />;
            },
        },
        {
            component: DefaultLayout,
            routes: [
                // ------------------------------------------------ Home ------------------------------------------
                {
                    path: '/home/dashboard',
                    name: i18n.t('Dashboard'),
                    exact: true,
                    component: isMasterAccount ?
                        () => <Redirect to='/reports/winloss_report' />
                        : lazy(() => import('pages/Dashboard'))
                },
                {
                    path: '/home/dashboard/online-member-list',
                    name: i18n.t('Total Global Members'),
                    exact: true,
                    component: lazy(() => import('pages/OnlineMemberList')),
                },
                // ------------------------------------------------ Home ------------------------------------------
                // ------------------------------------------------ Profile ------------------------------------
                {
                    path: '/profile',
                    name: i18n.t('Edit Profile'),
                    exact: true,
                    component: lazy(() => import('pages/Profile/ProfileEdit')),
                },
                // ------------------------------------------------ Home ------------------------------------------
                // ------------------------------------------------ Profile ------------------------------------
                {
                    path: '/settings/games',
                    name:
            currentUser?.account_type === 'admin' ||
              currentUser?.account_type === 'adminsub'
                ? i18n.t('Game Settings')
                : i18n.t('Games (for Member)'),
                    exact: true,
                    component: lazy(() => import('pages/Settings/GameSetting')),
                },
                {
                    path: '/settings/writer-games',
                    name: i18n.t('Games (for Writer)'),
                    exact: true,
                    component: lazy(() => import('pages/Settings/GameSetting')),
                },
                {
                    path: '/settings/limitline',
                    name: i18n.t('Limit Line'),
                    exact: true,
                    component: lazy(() => import('pages/Settings/LimitLine')),
                },
                // ------------------------------------------------ Pools Settings ---------------------------------------
                {
                    path: '/settings/pools/create',
                    name: i18n.t('Create Pools'),
                    exact: true,
                    component: lazy(() => import('pages/Pools/PoolCreate')),
                },
                {
                    path: '/settings/pools',
                    name: i18n.t('Pools List'),
                    exact: true,
                    component: lazy(() => import('pages/Pools')),
                },
                {
                    path: '/settings/periods-offline-online',
                    name: i18n.t('Pools List'),
                    exact: true,
                    component: lazy(() => import('pages/Pools/PeriodsOfflineOnline')),
                },
                {
                    path: '/settings/pools/:pool_id/edit',
                    name: i18n.t('Edit Pool'),
                    exact: true,
                    component: lazy(() => import('pages/Pools/PoolEdit')),
                },

                {
                    path: '/settings/sports-bet-settings',
                    name: i18n.t('Sports Bet Settings'),
                    exact: true,
                    component: lazy(() => import('pages/Settings/BetLimit')),
                },

                {
                    path: '/settings/agent_games',
                    name: i18n.t('Agent Game Settings'),
                    exact: true,
                    component: lazy(() => import('pages/Settings/AgentsGameSettings')),
                },
                ...accountType('admin') ? [
                    {
                        path: '/settings/tier-maintenance-requirement/:company_account_id',
                        name: i18n.t('Details'),
                        exact: true,
                        component: lazy(() => import('pages/Settings/TierMaintenanceRequirement'))
                    },
                    {
                        path: '/settings/tier-maintenance-requirement',
                        name: i18n.t('Tier Maintenance Requirement'),
                        exact: true,
                        component: lazy(() => import('pages/Settings/TierMaintenanceRequirementAdmin'))
                    }
                ] : [
                    {
                        path: '/settings/tier-maintenance-requirement',
                        name: i18n.t('Tier Maintenance Requirement'),
                        exact: true,
                        component: lazy(() => import('pages/Settings/TierMaintenanceRequirement'))
                    }
                ],

                // ------------------------------------------------ Profile ------------------------------------
                // ------------------------------------------------ Sub Account -----------------------------------
                {
                    path: '/sub/create',
                    name: i18n.t('Create Sub Account'),
                    exact: true,
                    component: lazy(() => import('pages/SubAccount/SubAccountCreate')),
                },
                {
                    path: '/sub/list',
                    name: i18n.t('Sub Account List'),
                    exact: true,
                    component: lazy(() => import('pages/SubAccount/SubAccountList')),
                },
                {
                    path: '/sub/list/:id/edit',
                    name: i18n.t('Edit Sub Account'),
                    exact: true,
                    component: lazy(() => import('pages/SubAccount/SubAccountEdit')),
                },
                // ------------------------------------------------ Sub Account ------------------------------------

                // ------------------------------------------------ Company ----------------------------------------
                {
                    path: '/company/create',
                    name: i18n.t('Create Company'),
                    exact: true,
                    component: lazy(() => import('pages/Companies/CompanyCreate')),
                },
                {
                    path: '/company/list',
                    name: i18n.t('Company List'),
                    exact: true,
                    component: lazy(() => import('pages/Companies/CompanyList')),
                },
                {
                    path: [
                        '/company/list/:company_id/pools',
                        '/whitelabel/list/:company_id/pools',
                        '/master/list/:company_id/pools',
                    ],
                    name: i18n.t('Pools List'),
                    exact: true,
                    component: lazy(() => import('pages/Companies/PoolsListCompany')),
                },
                {
                    path: [
                        '/company/list/:account_id/providers',
                        '/whitelabel/list/:account_id/providers',
                    ],
                    name: i18n.t('Enabled Providers'),
                    exact: true,
                    component: lazy(() => import('pages/Companies/EnabledProviders')),
                },
                {
                    path: '/company/list/:id/edit',
                    name: i18n.t('Edit Company'),
                    exact: true,
                    component: lazy(() => import('pages/Companies/CompanyEdit')),
                },
                {
                    path: [
                        '/company/list/:company_id/account/:account_id/member',
                        '/whitelabel/list/:company_id/account/:account_id/member',
                    ],
                    name: i18n.t('Member List'),
                    exact: true,
                    component: lazy(() => import('pages/Members/MemberList')),
                },
                {
                    path: [
                        '/company/list/:company_id/account/:account_id/member/:member_id/downline-list',
                        '/whitelabel/list/:company_id/account/:account_id/member/:member_id/downline-list',
                    ],
                    name: i18n.t('Referral List'),
                    exact: true,
                    component: lazy(() => import('pages/Members/MemberDownlineList')),
                },
                {
                    path: [
                        '/company/list/:company_id/account/:account_id/member/:member_id/transaction-history',
                        '/whitelabel/list/:company_id/account/:account_id/member/:member_id/transaction-history',
                    ],
                    name: i18n.t('Transaction History'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/TransactionHistory/TransactionHistory')
                    ),
                },
                // ========================= Tools Pazemo ========================//
                {
                    path: '/tools/vigor_pay', // This is for breadcrumb. Fake route
                    name: i18n.t('VigorPay'),
                    exact: true,
                    component: lazy(() => import('pages/Tools/PazemoGateway/PazemoList')),
                },
                {
                    path: '/tools/yukk_payment', // This is for breadcrumb. Fake route
                    name: i18n.t('Yukk Payment'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Tools/YukkPayment/YukkPaymentList.js')
                    ),
                },
                {
                    path: '/request-management/yukkpayment-deposit', // This is for breadcrumb. Fake route
                    name: i18n.t('Yukk Deposit'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Tools/YukkPayment/YukkDepositList.js')
                    ),
                },
                {
                    path: '/tools/kluwy_pay', // This is for breadcrumb. Fake route
                    name: i18n.t('Deposit Instant Payment'),
                    exact: true,
                    component: lazy(() => import('pages/Tools/KluwyPay/KluwyPayList.js')),
                },
                {
                    path: '/request-management/kluwypay-withdraw', // This is for breadcrumb. Fake route
                    name: i18n.t('WithdrawInstantRequestList'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Tools/KluwyPay/KluwyWithdrawList.js')
                    ),
                },
                {
                    path: '/request-management/kluwypay-deposit', // This is for breadcrumb. Fake route
                    name: i18n.t('Deposit Instant'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Tools/KluwyPay/KluwyDepositList.js')
                    ),
                },
                {
                    path: '/request-management/vigorpay-deposit', // This is for breadcrumb. Fake route
                    name: i18n.t('VigorPay Deposit'),
                    exact: true,
                    component: lazy(() => import('pages/Tools/PazemoGateway/PazemoDepositList')),
                },
                {
                    path: '/tools/autobank', // This is for breadcrumb. Fake route
                    name: i18n.t('Auto Bank'),
                    exact: true,
                    component: lazy(() => import('pages/Tools/AutoBank')),
                },
                {
                    path: '/tools/unopay_payment',
                    name: i18n.t('UnoPay Payment'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Tools/UnoPayment/UnoPaymentList/index')
                    ),
                },
                {
                    path: '/request-management/unopay-deposit',
                    name: i18n.t('UnoPay Deposit'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Tools/UnoPayment/UnoDepositList/index')
                    ),
                },
                {
                    path: '/request-management/coin2pay-deposit',
                    name: i18n.t('Coin2Pay Deposit'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Tools/Coin2PayDeposit')
                    ),
                },
                {
                    path: '/request-management/unopay-withdraw',
                    name: i18n.t('Unopay Withdraw'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Tools/UnoPayment/UnoWithdrawList')
                    ),
                },
                // ========================= Bank Comapny ========================//
                {
                    path: '/bank-management/account/create',
                    name: i18n.t('Create Bank Account'),
                    exact: true,
                    component: lazy(() => import('pages/Bank/BankAccountCreate.js')),
                },
                {
                    path: '/bank-management/account/list/:id/bank-transaction-list',
                    name: i18n.t('Account Transactions List'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Bank/BankAccountList/BankTransactions')
                    ),
                },
                {
                    path: '/bank-management/account/list',
                    name: i18n.t('Bank Account List'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Bank/BankAccountList/BankAccountList')
                    ),
                },
                {
                    path: '/bank-management/bank-group',
                    name: i18n.t('Bank Group'),
                    exact: true,
                    component: lazy(() => import('pages/Bank/BankGroupList.js')),
                },
                {
                    path: '/bank-management/limit-setting',
                    name: i18n.t('Bank Limit Setting'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Bank/BankLimitSetting/BankLimitSetting')
                    ),
                },
                {
                    path: '/settings/limit_transfer_bets',
                    name: i18n.t('Limit Transfer Bets'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/LimitTransferBets/LimitTransferBets')
                    ),
                },
                {
                    path: '/bank-management/display-bank',
                    name: i18n.t('Display Bank List'),
                    exact: true,
                    component: lazy(() => import('pages/Bank/DisplayBankList.js')),
                },
                {
                    path: '/bank-management/bank-balance',
                    name: i18n.t('Bank Balance'),
                    exact: true,
                    component: lazy(() => import('pages/Bank/BankBalance.js')),
                },
                {
                    path: '/bank-management/bank-account-banned',
                    name: i18n.t('Bank Account Banned'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Bank/BannedBankAccountList/BannedBankAccountList')
                    ),
                },
                {
                    path: '/company/transfer-log/list',
                    name: i18n.t('Bank Transfer Log'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Bank/BankTransferLogs/BankTransferLogs')
                    ),
                },
                // ------------------------------------------------ Requests Management ----------------------------------------
                {
                    path: '/request-management/deposit',
                    name: i18n.t('Deposit Request List'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/requestManagement')
                    ),
                },
                {
                    path: '/request-management/withdraw',
                    name: i18n.t('Withdraw Request List'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/requestManagement')
                    ),
                },

                {
                    path: '/request-management/:request_type/:member_id/transaction-history',
                    name: i18n.t('Transaction History'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/TransactionHistory/TransactionHistory')
                    ),
                },

                {
                    path: '/request-management/:username/:member_id/member-recent-actions',
                    name: i18n.t('Member Recent Actions'),
                    exact: true,
                    component: lazy(() => import('pages/MemberRecenActions')),
                },

                // ------------------------------------------------ Bank ----------------------------------------
                {
                    path: '/bank/list',
                    name: i18n.t('BankList'),
                    exact: true,
                    component: lazy(() => import('pages/Bank/BankList/BankList')),
                },

                {
                    path: '/bank/list/:id/edit',
                    name: i18n.t('EditArg', { arg: i18n.t('Bank') }),
                    exact: true,
                    component: lazy(() => import('pages/Bank/BankEdit')),
                },
                {
                    path: '/bank/create',
                    name: i18n.t('Create Bank'),
                    exact: true,
                    component: lazy(() => import('pages/Bank/BankCreate')),
                },
                {
                    path: '/bank-management/transfer-log/list',
                    name: i18n.t('Bank Transfer Log'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Bank/BankTransferLogs/BankTransferLogs')
                    ),
                },
                {
                    path: '/others_payment_method/list/:id/edit',
                    name: i18n.t('EditArg', { arg: i18n.t('Bank') }),
                    exact: true,
                    component: lazy(() =>
                        import(
                            'pages/Bank/BankList/OtherPaymentMethodsList/OtherPaymentMethodsEdit'
                        )
                    ),
                },
                // ------------------------------------------------ Bank ----------------------------------------

                // ------------------------------------------------ Result ----------------------------------------

                {
                    path: '/results/list', // This is for breadcrumb. Fake route
                    name: i18n.t('Result List'),
                    exact: true,
                    component: lazy(() => import('pages/Results/ResultList')),
                },
                {
                    path: '/results/list/add',
                    name: i18n.t('Add Result'),
                    exact: true,
                    component: lazy(() => import('pages/Results/ResultAdd')),
                },
                {
                    path: '/results/scan', // This is for breadcrumb. Fake route
                    name: i18n.t('Scan Result'),
                    exact: true,
                    component: lazy(() => import('pages/Results/ScanResult/ScanResult')),
                },
                {
                    path: '/results/analyze', // This is for breadcrumb. Fake route
                    name: i18n.t('Analyze Result'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Results/ScanResult/AnalyzeResult')
                    ),
                },
                // ------------------------------------------------ Member -----------------------------------------
                {
                    path: '/writer/create',
                    name: i18n.t('Create Writer'),
                    exact: true,
                    component: () => <Redirect to='/member/writer/create' />,
                },
                {
                    path: '/member/writer/create',
                    name: i18n.t('Create Writer'),
                    exact: true,
                    component: lazy(() => import('pages/Members/WriterCreate')),
                },
                {
                    path: '/member/list/writer/:id/edit',
                    name: i18n.t('Writer Edit'),
                    exact: true,
                    component: lazy(() => import('pages/Members/WriterEdit')),
                },
                {
                    path: '/member/create',
                    name: i18n.t('Create Member'),
                    exact: true,
                    component: lazy(() => import('pages/Members/MemberCreate')),
                },
                {
                    path: '/member/list',
                    name: i18n.t('Member List'),
                    exact: true,
                    component: lazy(() => import('pages/Members/MemberList')),
                },
                {
                    path: '/member/list/:id/edit',
                    name: i18n.t('Member Edit'),
                    exact: true,
                    component: lazy(() => import('pages/Members/MemberEdit')),
                },
                {
                    path: '/member/list/:member_id/downline-list',
                    name: i18n.t('Referral List'),
                    exact: true,
                    component: lazy(() => import('pages/Members/MemberDownlineList')),
                },
                {
                    path: '/member/list/:member_id/member_payment_account',
                    name: i18n.t('MemberPaymentAccountManagement'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Members/PaymentAccountManagement')
                    ),
                },
                {
                    path: '/member/tracking-cloned',
                    name: i18n.t('Tracking Cloned Members'),
                    exact: true,
                    component: lazy(() => import('pages/Members/TrackingCloneMember')),
                },
                {
                    path: '/settings/source-management',
                    name: i18n.t('Source Management'),
                    exact: true,
                    component: lazy(() => import('pages/Members/SourceManagement')),
                },
                {
                    path: '/member/list-by-source',
                    name: i18n.t('Member List By Source'),
                    exact: true,
                    component: lazy(() => import('pages/Members/MemberListBySource')),
                },
                {
                    path: [
                        '/member/tier-history',
                        '/global-member/tier-history'
                    ],
                    name: i18n.t('Tier History for Member'),
                    exact: true,
                    component: lazy(() => import('pages/Members/TierHistoryByMember')),
                },
                {
                    path: '/member/list/:member_id/b-management',
                    name: i18n.t('Bonus Management'),
                    exact: true,
                    component: lazy(() => import('pages/Bonus/MemberBonusManagement')),
                },
                {
                    path: [
                        '/company/list/:company_id/account/:account_id/member/:member_id/b-management',
                        '/whitelabel/list/:company_id/account/:account_id/member/:member_id/b-management',
                    ],
                    name: i18n.t('Bonus Management'),
                    exact: true,
                    component: lazy(() => import('pages/Bonus/MemberBonusManagement')),
                },
                // ------------------------------------------------ Transaction -----------------------------------------
                {
                    path: '/member/list/:member_id/transaction-history',
                    name: i18n.t('Transaction History'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/TransactionHistory/TransactionHistory')
                    ),
                },
                {
                    path: '/global-member/list', // This is for breadcrumb. Fake route
                    name: i18n.t('Global Member List'),
                    exact: true,
                    component: lazy(() => import('pages/GlobalMembers/GlobalMembers')),
                },
                {
                    path: '/global-member/list/:member_id/downline-list',
                    name: i18n.t('Referral List'),
                    exact: true,
                    component: lazy(() => import('pages/Members/MemberDownlineList')),
                },
                {
                    path: '/global-member/list/:member_id/transaction-history',
                    name: i18n.t('Transaction History'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/TransactionHistory/TransactionHistory')
                    ),
                },
                // {
                //   path: '/member/:member_id/transaction-history/:bet_id',
                //   name: i18n.t('Transaction Detail'),
                //   exact: true,
                //   component: lazy(() => import('pages/TransactionHistory/TransactionDetail')),
                // },
                {
                    path: [
                        '/global-member/list/:id/kyc_program',
                        '/member/list/:id/kyc_program',
                        '/company/list/:company_id/account/:account_id/member/:id/kyc_program',
                        '/whitelabel/list/:company_id/account/:account_id/member/:id/kyc_program',
                    ],
                    name: i18n.t('KYC Member'),
                    exact: true,
                    component: lazy(() => import('pages/KYCProgramInfo')),
                },

                // ------------------------------------------------ Bets -----------------------------------------
                {
                    path: '/bets/table',
                    name: i18n.t('Bets Table'),
                    exact: true,
                    component: lazy(() => import('pages/Bets/BetsTable/BetsTable')),
                },
                {
                    path: '/bets/list',
                    name: i18n.t('Bets List'),
                    exact: true,
                    component: lazy(() => import('pages/Bets/BetsList/BetsList')),
                },
                {
                    path: '/bets/transferred/list',
                    name: i18n.t('Transfer Bets'),
                    exact: true,
                    component: lazy(() => import('pages/TransferBets/TransferBets')),
                },
                {
                    path: '/bets/sport-running',
                    name: i18n.t('Sport Running'),
                    exact: true,
                    component: lazy(() => import('pages/Bets/SportRunning')),
                },

                // ------------------------------------------------ Report -----------------------------------------
                {
                    path: '/reports/referral_report',
                    name: i18n.t('Referral Report'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Report/ReferralReport')
                    ),
                },
                {
                    path: '/reports/referral_report/:member_id/downline_list',
                    name: i18n.t('Referral Downline list'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Report/ReferralReport/ReferralDownlineList')
                    ),
                },
                {
                    path: '/reports/writer_referral_report',
                    name: i18n.t('Writer Referral Report'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Report/WriterReferralReport/WriterReferralReport')
                    ),
                },
                {
                    path: '/reports/writer_referral_report/:id/detail',
                    name: i18n.t('Writer Referral Report Detail'),
                    exact: true,
                    component: lazy(() =>
                        import(
                            'pages/Report/WriterReferralReport/WriterReferralReportDetail'
                        )
                    ),
                },
                {
                    path: '/reports/winloss_report',
                    name: i18n.t('Win Loss Report'),
                    exact: true,
                    component:
            currentUser?.account_type === 'admin' ||
              currentUser?.account_type === 'adminsub' ||
              currentUser?.account_type === 'masterwhitelabel'
                ? lazy(() =>
                    import('pages/Report/WinLossReport/WinLossReportAdmin')
                )
                : lazy(() =>
                    import('pages/Report/WinLossReport/WinLossReportCompany')
                ),
                },

                {
                    path: '/reports/agent_daily_report',
                    name: i18n.t('Agent Daily Report'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Report/WinLossReport/AgentDailyWinLossReport')
                    ),
                },

                {
                    path: '/settings/winloss_report/members',
                    name: i18n.t('Win Loss Report Members'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Report/WinLossReport/MemberWinLoss')
                    ),
                },
                {
                    path: '/reports/winloss_report/member/:member_id/transaction-history',
                    name: i18n.t('Win Loss Report Members'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Report/WinLossReport/WinLossTransactionHistory')
                    ),
                },
                {
                    path: '/reports/togel_lost_money_report',
                    name: i18n.t('Togel Lost Money Report'),
                    exact: true,
                    component: lazy(() => import('pages/Report/TogelLostMoneyReport')),
                },
                {
                    path: '/reports/lost_money_report',
                    name: i18n.t('Lost Money Report'),
                    exact: true,
                    component: lazy(() => import('pages/Report/LostMoneyReport')),
                },
                {
                    path: '/reports/top_turnover_members',
                    name: i18n.t('Top Turnover Members'),
                    exact: true,
                    component: lazy(() => import('pages/Report/TopTurnoverMembers')),
                },
                {
                    path: '/reports/eslot_turnover_report',
                    name: i18n.t('J E-Slot Turnover Report'),
                    exact: true,
                    component: lazy(() => import('pages/Report/JESlotTurnoverReport')),
                },
                {
                    path: '/reports/limit_credit',
                    name: i18n.t('Limit Credit Report'),
                    exact: true,
                    component: lazy(() => import('pages/Report/LimitCreditReport')),
                },

                // ------------------------------------------------ Monthly Invoice ---------------------------------------
                {
                    path: '/monthly_invoice/tournament_winner_list',
                    name: i18n.t('Tournament Winner List'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/MonthlyInvoice/MonthlyInvoiceCompany')
                    ),
                },

                {
                    path: '/monthly_invoice/file_management',
                    name: i18n.t('File Management'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/MonthlyInvoice/MonthlyInvoiceFileManagement')
                    ),
                },

                {
                    path: '/monthly_invoice/monthly_invoice',
                    name: i18n.t('monthly-invoice'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/MonthlyInvoice/MonthlyInvoiceList')
                    ),
                },

                {
                    path: '/monthly_invoice/billing_report',
                    name: i18n.t('Billing Report'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/MonthlyInvoice/BillingReport')
                    ),
                },

                {
                    path: '/monthly_invoice/agent_tier_report',
                    name: i18n.t('Agent Tier Report'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/MonthlyInvoice/AgentTierReport')
                    ),
                },

                {
                    path: '/monthly_invoice/payment_history',
                    name: i18n.t('Payment History'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/MonthlyInvoice/PaymentHistory')
                    ),
                },

                {
                    path: '/monthly_invoice/payment_history/:company_account_id',
                    name: i18n.t('Details'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/MonthlyInvoice/PaymentHistoryDetail')
                    ),
                },

                // ------------------------------------------------ Settings ---------------------------------------
                {
                    path: '/settings/referral-rate',
                    name: i18n.t('Referral Rate'),
                    exact: true,
                    component: lazy(() => import('pages/Settings/Referral/Referral')),
                },
                {
                    path: '/settings/writer-referral-rate',
                    name: i18n.t('Writer Referral Rate'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Settings/Referral/WriterReferralRate')
                    ),
                },
                {
                    path: '/settings/commission',
                    name: i18n.t('Commission'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Settings/Commission')
                    ),
                },
                {
                    path: '/settings/commission/:company_account_id',
                    name: i18n.t('Edit Commission'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Settings/Commission/CommissionDetail')
                    ),
                },
                {
                    path: '/settings/togel_commission',
                    name: i18n.t('Togel Commission'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Settings/TogelCommission/index.js')
                    ),
                },
                {
                    path: '/settings/limit_credit_out',
                    name: i18n.t('Limit Credit Out'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Settings/LimitCreditOut/LimitCreditOutList.js')
                    ),
                },
                {
                    path: '/settings/agent-referral-rate',
                    name: i18n.t('Agent Referral Rate'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Settings/AgentReferralRate')
                    ),
                },
                {
                    path: '/settings/limit_host',
                    name: i18n.t('Host Limit'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Settings/HostLimit')
                    ),
                },
                // ------------------------------------------------ Action log ---------------------------------------
                {
                    path: '/action-log/c-company-logs',
                    name: i18n.t('Company Log'),
                    exact: true,
                    component: lazy(() => import('pages/Log/LogList')),
                },
                {
                    path: '/action-log/admin-logs',
                    name: i18n.t('Admin Log'),
                    exact: true,
                    component: lazy(() => import('pages/Log/LogList')),
                },
                {
                    path: '/action-log/member-logs',
                    name: i18n.t('Member Log'),
                    exact: true,
                    component: lazy(() => import('pages/Log/LogList')),
                },
                {
                    path: '/action-log/master-whitelabel-logs',
                    name: i18n.t('Master Log'),
                    exact: true,
                    component: lazy(() => import('pages/Log/LogList')),
                },

                {
                    path: '/action-log/c-whitelabel-logs',
                    name: i18n.t('Whitelabel Log'),
                    exact: true,
                    component: lazy(() => import('pages/Log/LogList')),
                },
                // ------------------------------------------------ Customization ---------------------------------------
                {
                    path: '/ctmzt/site_config',
                    name: i18n.t('Site Config'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Customization/SiteConfig/SiteConfig')
                    ),
                },
                {
                    path: '/ctmzt/running_text',
                    name: i18n.t('Running Text'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Customization/RunningText/RunningText')
                    ),
                },
                {
                    path: '/ctmzt/web_page',
                    name: i18n.t('Web Page'),
                    exact: true,
                    component: lazy(() => import('pages/Customization/Webpage/Webpage')),
                },
                {
                    path: '/ctmzt/customer_service',
                    name: i18n.t('Customer Service'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Customization/CustomerService/CustomerService')
                    ),
                },
                {
                    path: '/ctmzt/information',
                    name: i18n.t('Information'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Customization/Information/Information')
                    ),
                },
                {
                    path: '/ctmzt/promotion',
                    exact: true,
                    component: () => <Redirect to='/ctmzt/promotion/list' />,
                },
                {
                    path: '/ctmzt/promotion/list',
                    name: i18n.t('Promotion'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Customization/Promotion/Promotion')
                    ),
                },
                {
                    path: '/ctmzt/promotion/add',
                    name: i18n.t('Add Promotion'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Customization/Promotion/PromotionAdd')
                    ),
                },
                {
                    path: '/ctmzt/global_promotion',
                    exact: true,
                    component: () => <Redirect to='/ctmzt/global_promotion/list' />,
                },

                {
                    path: '/ctmzt/global_promotion/list',
                    name: i18n.t('Global Promotion'),
                    exact: true,
                    component: lazy(() => import('pages/Customization/GlobalPromotion')),
                },
                {
                    path: '/ctmzt/global_promotion/add',
                    name: i18n.t('Add Global Promotion'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Customization/GlobalPromotion/PromotionAdd')
                    ),
                },

                {
                    path: '/ctmzt/banner',
                    name: i18n.t('Banners'),
                    exact: true,
                    component: lazy(() => import('pages/Customization/Banners/Banners')),
                },
                {
                    path: '/ctmzt/global_banner',
                    name: i18n.t('Global Banner'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Customization/Banners/GlobalBanners')
                    ),
                },
                {
                    path: '/ctmzt/template',
                    name: i18n.t('Templates List'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Customization/TemplatesList/TemplatesList')
                    ),
                },

                {
                    path: '/ctmzt/app_notication',
                    name: i18n.t('Notification List'),
                    exact: true,
                    component: lazy(() => import('pages/Customization/Notifications')),
                },
                {
                    path: '/ctmzt/app_notication/add',
                    name: i18n.t('Notification Add'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Customization/Notifications/NotificationAdd')
                    ),
                },
                {
                    path: '/ctmzt/app_notication/:id/edit',
                    name: i18n.t('Notification Edit'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Customization/Notifications/NotificationEdit')
                    ),
                },
                {
                    path: '/ctmzt/global_popular_games',
                    name: i18n.t('Global Popular Games'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Customization/GlobalPopularGames')
                    ),
                },
                {
                    path: '/ctmzt/amp_site',
                    name: i18n.t('AMP Site'),
                    exact: true,
                    component: lazy(() => import('pages/Customization/AMPPage')),
                },
                {
                    path: '/ctmzt/button_widget',
                    name: i18n.t('Button Widget'),
                    exact: true,
                    component: lazy(() => import('pages/Customization/CustomerWidgets')),
                },
                {
                    path: '/ctmzt/the-last-winners',
                    name: i18n.t('The Last Winners'),
                    exact: true,
                    component: lazy(() => import('pages/Customization/LastWinnerRecentBigWins')),
                },
                {
                    path: '/ctmzt/top-rated-games',
                    name: i18n.t('Top Rated Games'),
                    exact: true,
                    component: lazy(() => import('pages/Customization/TopRatedGames')),
                },

                {
                    path: '/ctmzt/custom-template',
                    name: i18n.t('Custom Template'),
                    exact: true,
                    component: lazy(() => import('pages/CustomMode')),
                },

                // {
                //     path: '/ctmzt/smartico-icon',
                //     name: i18n.t('Smartico Icon'),
                //     exact: true,
                //     component: lazy(() => import('pages/Customization/SmarticoIcon')),
                // },

                // // ------------------------------------------------ Bonus ---------------------------------------
                {
                    path: '/bonus/free_bet/list',
                    name: i18n.t('Free Bet'),
                    exact: true,
                    component: lazy(() => import('pages/Bonus/FreeBet/FreeBet')),
                },
                {
                    path: '/bonus/free_bet/list/:freebet_id/edit',
                    name: i18n.t('Edit Free Bet'),
                    exact: true,
                    component: lazy(() => import('pages/Bonus/FreeBet/EditFreeBet')),
                },
                {
                    path: '/bonus/free_bet/list/create',
                    name: i18n.t('Add New Bonus'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Bonus/FreeBet/CreateFreeBetForm')
                    ),
                },
                {
                    path: '/bonus/free_bet/report',
                    name: i18n.t('Free Bet Report'),
                    exact: true,
                    component: lazy(() => import('pages/Bonus/FreeBet/ReportFreeBet')),
                },
                {
                    path: '/bonus/free_bet/lucky_spin_bonus',
                    name: i18n.t('Lucky Spin For Newcomer'),
                    exact: true,
                    component: lazy(() => import('pages/Bonus/FreeBet/LuckySpinBonus')),
                },
                {
                    path: '/bonus/upload_bonus',
                    name: i18n.t('Upload Bonus'),
                    exact: true,
                    component: lazy(() => import('pages/Bonus/UploadBonus/UploadBonus')),
                },
                {
                    path: '/bonus/bonus_report',
                    name: i18n.t('Bonus Report'),
                    exact: true,
                    component: lazy(() => accountType('admin') ?
                        import('pages/Bonus/BonusReportAdmin') :
                        import('pages/Bonus/BonusReport')),
                },

                {
                    path: '/bonus/tracking',
                    name: i18n.t('Bonus Tracking'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/Bonus/BonusReport/BonusTrackingReport')
                    ),
                },
                {
                    path: '/bonus/agent_freebet',
                    name: i18n.t('Agent FreeBet'),
                    exact: true,
                    component: lazy(() => import('pages/Bonus/AgentFreebet')),
                },

                {
                    path: '/bonus/agent_freebet/:freebet_id/edit',
                    name: i18n.t('Edit Free Bet'),
                    exact: true,
                    component: lazy(() => import('pages/Bonus/FreeBet/EditFreeBet')),
                },

                {
                    path: '/bonus/agent_freebet_report',
                    name: i18n.t('Agent FreeBet Report'),
                    exact: true,
                    component: lazy(() => import('pages/Bonus/AgentFreebetReport')),
                },
                {
                    path: '/bonus/pragmatic_frb',
                    name: i18n.t('Pragmatic Play Free Rounds'),
                    exact: true,
                    component: lazy(() => import('pages/Bonus/PragmaticPlayFreeRounds')),
                },
                {
                    path: '/bonus/daily_spin_bonus/list',
                    name: i18n.t('Daily Spin Bonus'),
                    exact: true,
                    component: lazy(() => import('pages/Bonus/DailySpinBonus')),
                },
                {
                    path: '/bonus/daily_spin_bonus/report',
                    name: i18n.t('Daily Spin Bonus Report'),
                    exact: true,
                    component: lazy(() => import('pages/Bonus/DailySpinBonusReport')),
                },
                {
                    path: '/bonus/display_freebet_list',
                    name: i18n.t('Display FreeBet List'),
                    exact: true,
                    component: lazy(() => import('pages/Bonus/DisplayFreebetList')),
                },
                // ------------------------------------------------ Memo ---------------------------------------
                {
                    path: '/memo/memo',
                    name: i18n.t('Memo'),
                    exact: true,
                    component: lazy(() => import('pages/Memo/Memo')),
                },
                {
                    path: '/memo/auto-memo',
                    name: i18n.t('Auto Memo'),
                    exact: true,
                    component: lazy(() => import('pages/Memo/AutoMemo/AutoMemo')),
                },
                {
                    path: '/memo/block-memo',
                    name: i18n.t('Block Memo by Member'),
                    exact: true,
                    component: lazy(() => import('pages/Memo/BlockMemo')),
                },
                // ------------------------------------------------ Whitelabel ----------------------------------------
                {
                    path: '/whitelabel/create',
                    name: i18n.t('Create Whitelabel'),
                    exact: true,
                    component: lazy(() => import('pages/Whitelabel/WhitelabelCreate')),
                },
                {
                    path: '/whitelabel/list',
                    name: i18n.t('Whitelabel List'),
                    exact: true,
                    component: lazy(() => import('pages/Whitelabel/WhitelabelList')),
                },
                {
                    path: '/whitelabel/list/:id/edit',
                    name: i18n.t('Edit Whitelabel'),
                    exact: true,
                    component: lazy(() => import('pages/Whitelabel/WhitelabelEdit')),
                },
                {
                    path: '/block-numbers',
                    name: i18n.t('Edit Whitelabel'),
                    exact: true,
                    component: lazy(() => import('pages/BlockNumbers/BlockNumbers')),
                },
                // ------------------------------------------------ Master Customer ----------------------------------------

                {
                    path: '/master-customer/master-customer',
                    name: i18n.t('Master Customer'),
                    exact: true,
                    component: lazy(() => import('pages/MasterCustomer')),
                },
                // ------------------------------------------------ Master Whitelabel ----------------------------------------
                {
                    path: '/master_whitelabel/create',
                    name: i18n.t('Create Master Account'),
                    exact: true,

                    component: lazy(() =>
                        import('pages/MasterWhitelabel/MasterWhitelabelCreate')
                    ),
                },
                {
                    path: '/master_whitelabel/list',
                    name: i18n.t('Master Account List'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/MasterWhitelabel/MasterWhitelabelList')
                    ),
                },
                {
                    path: '/master_whitelabel/list/:id/edit',
                    name: i18n.t('Edit Master Account'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/MasterWhitelabel/MasterWhitelabelEdit')
                    ),
                },
                {
                    path: '/master_whitelabel/list/:master_id/whitelabel/downline-list',
                    name: i18n.t('Downline List'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/MasterWhitelabel/MasterDownlineList')
                    ),
                },
                // ------------------------------------------------ Provider daily report ---------------------------------------
                {
                    path: arDailyReport,
                    name: i18n.t(' Daily Reports'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/ProviderDailyReport/ProviderDailyReport')
                    ),
                },
                // ------------------------------------------------ else ---------------------------------------
                {
                    path: ['/', '/login'],
                    exact: true,
                    component: () => {
                        if (isMasterAccount) {
                            return <Redirect to='/reports/winloss_report' />;
                        }
                        return <Redirect to='/home/dashboard' />;
                    },
                },
                {
                    path: '/home/device-report',
                    name: i18n.t('Device Report'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/DeviceReport/DeviceReport')
                    ),
                },
                {
                    path: '/home/provider-analytics',
                    name: i18n.t('Provider Analytics'),
                    exact: true,
                    component: lazy(() =>
                        import('pages/ProviderAnalytics')
                    ),
                },

                // ------------------------------------------------ TOOLS ---------------------------------------
                {
                    path: '/tools/maintenance',
                    name: i18n.t('Maintenance'),
                    exact: true,
                    component: lazy(() => import('pages/Tools/Maintenances')),
                },
                {
                    path: '/tools/host',
                    name: i18n.t('Host'),
                    exact: true,
                    component: lazy(() => import('pages/Tools/Host')),
                },
                {
                    path: '/tools/reason',
                    name: i18n.t('Reason'),
                    exact: true,
                    component: lazy(() => import('pages/Tools/Reason')),
                },
                {
                    path: '/tools/sawala',
                    name: i18n.t('Sawala'),
                    exact: true,
                    component: lazy(() => import('pages/Tools/Sawala')),
                },
                {
                    path: '/tools/smartico',
                    name: i18n.t('Smartico'),
                    exact: true,
                    component: lazy(() => import('pages/Tools/Smartico')),
                },
                {
                    path: '/tools/dw_notification_setting',
                    name: i18n.t('Notification Setting'),
                    exact: true,
                    component: lazy(() => import('pages/Tools/SoundNotificationSetting')),
                },
                {
                    path: '/tools/coin2pay',
                    name: i18n.t('Coin2Pay'),
                    exact: true,
                    component: lazy(() => import('pages/Tools/Coin2Pay')),
                },
                // ------------------------------------------------ end tool ---------------------------------------
                {
                    path: '/home/statistics',
                    name: i18n.t('Statistics'),
                    exact: true,
                    component: lazy(() => import('pages/Statistic')),
                },

                // ------------------------------------------------ Landing Page ---------------------------------------

                {
                    path: '/landing-page/web-page',
                    name: i18n.t('Web Page'),
                    exact: true,
                    component: lazy(() => import('pages/LandingPage/Webpage')),
                },
                {
                    path: '/landing-page/content',
                    name: i18n.t('Content'),
                    exact: true,
                    component: lazy(() => import('pages/LandingPage/Content')),
                },
                {
                    path: '/landing-page/banners',
                    name: i18n.t('Banners'),
                    exact: true,
                    component: lazy(() => import('pages/LandingPage/Banners')),
                },
                {
                    path: '/landing-page/customer-service',
                    name: i18n.t('Customer Service'),
                    exact: true,
                    component: lazy(() => import('pages/LandingPage/CustomerService')),
                },

                /* Commercial Account */
                {
                    path: '/commercial/create',
                    name: i18n.t('Create Commercial'),
                    exact: true,
                    component: lazy(() => import('pages/CommercialAccount/CommercialCreate')),
                },
                {
                    path: '/commercial/list',
                    name: i18n.t('Commercial List'),
                    exact: true,
                    component: lazy(() => import('pages/CommercialAccount/CommercialList')),
                },
                {
                    path: '/commercial/list/:account_id/edit',
                    name: i18n.t('Commercial Edit'),
                    exact: true,
                    component: lazy(() => import('pages/CommercialAccount/CommercialEdit')),
                },

                // ------------------------------------------------ else ---------------------------------------]
                {
                    path: '/*',
                    component: lazy(() => import('pages/Pages/Page404/Page404.js')),
                },
            ],
        },
    ];

    return privateRoutes;
};

export default routesPathLottery;
